<template>
  <div class="col-12 col-lg-6 pl-1">
    <div class="ibox mb-2">
      <div class="ibox-title style_2">
        <h5>{{ $t("navigations.import study") }}</h5>
        <div class="ibox-tools"></div>
      </div>
      <div class="ibox-content">
        <div
          class="import-box mb-3"
          :class="{ 'import-box--active': dragActive, 'import-box--disabled': !!studyFile }"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
          :style="{ pointerEvents: studyFile ? 'none' : 'auto', opacity: studyFile ? 0.6 : 1 }"
        >
          <h6>Drag & drop study files here</h6>
          <p class="text-muted mb-0">or click to browse files</p>
          <input ref="fileInput" accept=".xls,.xlsx" type="file" class="d-none" @change="previewFiles" />
          <div v-if="studyFile" class="uploaded-file mt-2">
            <i class="fa fa-file-excel-o me-2"></i> {{ studyFile.name }}
            <!-- <i class="fa fa-times ms-2 cursor-pointer" @click.stop="removeFile"></i> -->
          </div>
          <div class="mt-2">
            <button class="btn btn-primary btn-sm py-0" @click="browseFiles" type="button" :disabled="!!studyFile">
              <i class="fa fa-folder me-2"></i> Browse Files
            </button>
          </div>
        </div>

        <div class="al_min-height alert-light d-flex justify-content-between mb-0 py-2">
          <div>
            <small><strong>Supported format:</strong> .xlsx, .xls</small>
          </div>
          <div class="cursor-pointer" @click="downloadImportTemplate">
            <small>
              Download the template and follow the format
              <i class="fa fa-download me-1"></i>
            </small>
          </div>
        </div>
        <span v-if="validations[0]==true" class="errorClass">
          {{ t("navigations.please upload an xlsx or xlx file") }}
        </span>
        <span v-if="validations[1]==true" class="errorClass">
          {{ t("navigations.please upload a file") }}
        </span>
        <div class="d-flex justify-content-end mt-3">
          <button v-if="showCancel==true" class="btn btn-outline-secondary me-2 btn-sm py-0" type="button" :disabled="showLoading"
            @click="removeFile">
            <i class="fa fa-times me-1"></i> Cancel
          </button>
          <button
            v-if="rollsprivilages.includes('Studylist Concept map Builder')"
            class="btn btn-primary btn-sm me-2 py-0"
            type="button"
            :disabled="showLoading"
            @click="importSoA"
          >
            <i class="fa fa-upload me-1"></i> {{
              $t("navigations.Concept map Builder") }}
          </button>
          <button
            v-if="rollsprivilages.includes('Studylist Import Study')"
            class="btn btn-primary btn-sm  position-relative py-0"
            type="button"
            :disabled="showLoading"
            @click="importStudy"
          >
            <div class="toc-loader position-absolute"
              :class="{ 'opacity-0': showLoading == false, 'opacity-1': showLoading == true }">
              <img src="../../assets/img/loading.gif" class="loading-btn-img" width="15" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': showLoading == false, 'opacity-0': showLoading == true }">{{
              $t("navigations.import study") }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
  <customModal v-if="initialStudyLoader==true" :containersm=true :hideClose="true">
    <template #title>
      {{ $t("navigations.import study") }}
    </template>
    <template #body>
      <div class="progress mb-3">
        <div 
            class="progress-bar progress-bar-striped progress-bar-animated h-100" 
            role="progressbar" 
            :style="{ width: progress + '%' }" 
            :aria-valuenow="progress" 
            aria-valuemin="0" 
            aria-valuemax="100"
          >
            {{ progress }}%
          </div>
      </div>
      <div class="text-center">
        <p class="mb-1">Processing: {{ currentProcessingFile }}</p>
        <p class="mb-0 text-muted small">Please don't close this window</p>
      </div>
    </template>
  </customModal>
</template>

<script setup>
import { defineComponent, onMounted, defineEmits, ref, computed } from "vue";
import jwt_decode from "jwt-decode";
import { useStore } from "vuex";
import axios from "axios";
import { useI18n } from "vue-i18n";
import customModal from "../customModal/customModal.vue";

    const store = useStore();
    const { t } = useI18n({ useScope: "global" });
    const baseapi = `${process.env.VUE_APP_Service_URL}/management/study/`;
    const baseurl = `${process.env.VUE_APP_Service_URL}`;
    const dragActive = ref(false);
    const fileInput = ref(null);
    const emit = defineEmits(['returnStudyId'])
    const showLoading = ref(false);
    const studyFile = ref(null);
    const validations = ref([false,false]);
    const progress = ref(0); 
    const currentProcessingFile = ref(''); 
    const initialStudyLoader=ref(false)
    const showCancel = ref(false)
    const selectedFile=ref("")
    const rollsprivilages = computed(() => store.getters.getRolesprivilegeData || "");
    //  onMounted(async () => {
    //   studyFile.value=null
    // })
    function onDragOver() { dragActive.value = true; }
    function onDragLeave() { dragActive.value = false; }
    function onDrop(e) {
      dragActive.value = false;
      const file = e.dataTransfer.files[0];
      selectedFile.value=file.name
      showCancel.value=true 
      if (file && /\.(xls|xlsx)$/i.test(file.name)) {
        studyFile.value = file;
        validations.value = [false, false];
      } else if (!file) {
        studyFile.value = null;
        validations.value[1] = true;  // No file uploaded
      } else {       
        studyFile.value = null;
        validations.value[0] = true;// File uploaded, but invalid type
   
      }
    }

    function browseFiles() {
      fileInput.value && fileInput.value.click();
    }
    function removeFile() {
      validations.value=[false,false]
      studyFile.value = null;
      if (fileInput.value) fileInput.value.value = "";
      showCancel.value=false
    }

    function previewFiles(event) {
      const file = event.target.files[0];
      selectedFile.value=file.name
      showCancel.value=true
      if (file && /\.(xls|xlsx)$/i.test(file.name)) {
        studyFile.value = file;
        validations.value = [false, false];
      } else if (!file) {
        studyFile.value = null;
        validations.value[1] = true;  // No file uploaded
      } else {
        studyFile.value = null;
        validations.value[0] = true;  // File uploaded, but invalid type
        
      }
    }

    async function validateNull() {
      if(!studyFile.value){
        validations.value[1] = true;
      }      
    }

    async function importStudy() {
      await importFile("study");
    }

    async function importSoA() {
      await importFile("soa");
    }

    async function importFile(type) {
      await validateNull();
      if (validations.value[1] === true) return;

      initialStudyLoader.value = true;
      showLoading.value = true;
      progress.value = 0;
      const isSoAImport = type === "soa";
      currentProcessingFile.value = isSoAImport
        ? "Uploading SoA file..."
        : "Uploading study file...";

      const idtoken = store.getters.getIdToken;
      const formData = new FormData();
      formData.append("file", studyFile.value);

      let fakeProgress = 0;
      let progressTimer = setInterval(() => {
        if (fakeProgress < 100) {
          fakeProgress += 1;
          progress.value = fakeProgress;
        } else {
          clearInterval(progressTimer);
        }
      }, 70); 

      try {
        const res = await axios.post(
          isSoAImport
            ? `${baseurl.value}/management/studyimport/upload`
            : `${baseapi}import`,
          formData,
          {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "multipart/form-data",
          },
          ...(isSoAImport ? {} : { responseType: "blob" }),
        });

        clearInterval(progressTimer);
        currentProcessingFile.value = isSoAImport
          ? "Processing complete."
          : "Processing complete. Preparing download...";
        progress.value = 100;
        

        if (res.headers && res.headers["studyid"]) {
          emit("returnStudyId", res.headers["studyid"]);
          changeStudyList();
          studychange(res.headers["studyid"]);
        }

        if (!isSoAImport) {
          // Handle download
          let fileName = "study_results.xlsx";
          const disposition = res.headers["content-disposition"];
          const matches = disposition && /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches && matches[1]) fileName = matches[1].replace(/['"]/g, "");

          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();

          currentProcessingFile.value = `Download Complete: ${fileName}`;
        }
        alert(isSoAImport ? "SoA imported successfully" : "Study imported successfully");

      } catch (err) {
        clearInterval(progressTimer);
        progress.value = 0;
        currentProcessingFile.value = '';

        initialStudyLoader.value = false;
        
        let errMsg = "Something went wrong";

        if (err.response && err.response.data instanceof Blob) {
          try {
            const text = await err.response.data.text();
            const errorData = JSON.parse(text);
            const validationErrors = errorData.errors ? errorData.errors.DomainValidations : [];

            if (validationErrors.includes("Import Failed Invalid Study")) {
              errMsg = "Import Failed - Invalid Study Id/Study Name";
              showCancel.value=false
              removeFile();
            } else if (validationErrors.includes("Invalid File Type")) {
              errMsg = "Import Failed - Invalid File Type. Please upload a valid file.";
              showCancel.value=false
              removeFile();
            }
          } catch {
            /* ignore */
          }
        }
        alert(errMsg);
      } finally {
        showLoading.value = false;
        initialStudyLoader.value = false;
        progress.value = 0;
        currentProcessingFile.value = '';
      }
    }    


    async function changeStudyList() {
      const idtoken = store.getters.getIdToken;
      const usermail = jwt_decode(idtoken).email;
      await axios.get(`${baseapi}getallstudy?user=${usermail}`, {
        headers: {
          Authorization: `Bearer ${idtoken}`,
          "Content-Type": "application/json",
        }
      })
        .then((res) => {
          window.dispatchEvent(
            new CustomEvent("StudyListChanged", {

            })
          );
        })
    }
    async function studychange(val) {
      await store.dispatch("setStudyID", val);
      window.dispatchEvent(
        new CustomEvent("studyIdChanged", {
          detail: {
            storage: store.getters.getStudyIs,
          },
        })
      );
    }
    async function downloadImportTemplate() {
      showLoading.value = true;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(`${baseapi}downloadimporttemplate`, {
          headers: { Authorization: `Bearer ${idtoken}` },
          responseType: "blob",
        });

        let fileName = "import_template.xlsx";
        const disposition = res.headers["content-disposition"] || res.headers["Content-Disposition"];
        const matches = disposition && /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches && matches[1]) fileName = matches[1].replace(/['"]/g, "");

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        alert("Import template downloaded successfully");
      } catch (err) {
        console.error(err);
        alert("Something went wrong during the download. Please check console for details.");
      } finally {
        showLoading.value = false;
      }
    }

    async function loadStudies() {
      const idtoken = store.getters.getIdToken;
      const usermail = JSON.parse(atob(idtoken.split('.')[1])).email;
      try {
        const response = await axios.get(`${baseapi}getallstudy?user=${usermail}`, {
          headers: { Authorization: `Bearer ${idtoken}` }
        });
        store.dispatch("setStudies", response.data);
      } catch (err) {
        console.error(err);
      }
    }
</script>


<style scoped>
.progress {
  height: 20px;
  border-radius: 12px;
  overflow: hidden;
  margin: 15px 0;
}

.progress-bar {
  font-weight: 600;
  background-color: #145faf;
}
.import-box {
  border: 2px dashed #618bd7;
  border-radius: 5px;
  padding: 2rem 1rem;
  text-align: center;
  background: #f7fafd;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  position: relative;
}

.import-box--active {
  border-color: #3867d6;
  background: #eaf1ff;
}

.uploaded-file {
  color: #618bd7;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
}

.fa-file-excel-o {
  color: #218838;
}

.cursor-pointer {
  cursor: pointer;
}

.ml-2 {
  margin-left: 0.5rem;
}

/* error message under the file-input */
.errorClass {
  color: #e03e2d;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

/* a bit of breathing room around the loading spinner */
.loading-img {
  margin-right: 0.5rem;
  vertical-align: middle;
}

/* divider under your title bar */
.modal_title {
  border-bottom: 1px solid #e0e0e0;
}

/* space out the download‐template line a little */
.modal__upload__content>.mb-4 {
  line-height: 1.6;
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
/* if you need to override Bootstrap’s input-group defaults */
.input-group {
  display: flex;
  align-items: center;
}

.input-group-append {
  margin-left: -1px;
  /* visually connect the button to the input */
}

.modal_wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.modal_container {
  position: fixed;
  width: min(40%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.stdy_upload_btn {
  text-align: center;
  background-color: #618bd7 !important;
  border-color: #618bd7 !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transition: all 0.3s ease-in-out !important;
}
</style>
